<template>
  <v-layout row class="wrap2 vperfmarginunset pa-0">

    <v-flex d-flex xs12 v-if="displayFavouriteBadge" mb-2>
      <v-layout row child-flex align-center text-center elevation-0 class="favoritelinelayout wrap2 rounded-card topCard" @click="loadPerfumeDetails(perfFav, perfFav, true, 'true', 'true')">
        <v-icon :color="redColor" class="pr-2 favoriteIcon xs2 ">favorite</v-icon>
        <v-flex xs2 d-flex text-xs-right>
          <v-img
                  :src="perfFav.thumb_image_url"
                  contain
                  height="120px"
          ></v-img>
        </v-flex>
        <v-layout xs6 column fill-height>
          <v-flex style="display: flex" xs12 class="font-weight-bold flex"><span class="perfName">{{perfFav.name[this.locale || 'en']}}</span></v-flex>
          <v-flex xs12 class="font-weight-bold perfBrand" >{{perfFav.brand_name[this.locale || 'en']}}</v-flex>
        </v-layout>
      </v-layout>

    </v-flex>

    <div v-if="displayFavouriteBadge" class="sectionTitle mb-2">{{ourselection}}</div>
    <v-flex d-flex xs12 elevation-0 carddetails2>
      <v-list three-line class="orders3-layout rounded-card" elevation-0 v-bind:class="{ layoutheight1 : displayFavouriteBadge }">
        <template v-for="(similar, index) in similars">

          <v-flex d-flex :key="similar.title"  >
            <v-layout row child-flex align-center text-center mx-1 my-1 class="favoritelinelayout" @click="loadPerfumeDetails(similar, perfFav, true, loadurl, loadingredients)">
                <v-flex xs2><v-progress-circular :color="redColor" size="40" width= "5" :value="similar.rank*100" class="match2">{{index+1}}</v-progress-circular>
                </v-flex>
              <v-flex d-flex xs2 text-xs-right>
                <v-img
                        :src="similar.thumb_image_url"
                        contain
                        height="120px"
                ></v-img>
              </v-flex>
              <v-layout xs6 column fill-height>
                <v-flex style="display: flex" xs12 class="font-weight-bold flex"><span class="perfName">{{similar.name}}</span></v-flex>
                <v-flex xs12 class="font-weight-bold perfBrand" >{{similar.brand.name}}</v-flex>
              </v-layout>
            </v-layout>

          </v-flex>

        </template>
      </v-list>
    </v-flex>

  </v-layout>
</template>
<script>
  import toolsMixin from "../mixin/toolsMixin"

  export default {
    name: 'MatchesList',
    mixins: [toolsMixin],

    data () {
      return {
        pfokey: "tbd",
        customerkey: "tbd",
        similars:[],
        twocolors: 'rgba(30,30,30,1)',
        currentUrl: null,
        loadingredients: process.env.VUE_APP_LOAD_INGREDIENTS,
        loadurl: process.env.VUE_APP_LOAD_URL
      }
    },
    props: {
      perfFav: {
        type: Object,
        default: () => null
      },
      locale: {
        type: String,
        default: () => 'en'
      },
      country: {
        type: String,
        default: () => 'UK'
      },
      displayFavouriteBadge: {
        type: Boolean,
        default: () => true
      },
    },
    computed: {
      ourselection() {
        if (this.locale==="en") return process.env.VUE_APP_SHOP_SUGGESTION_EN
        if (this.locale==="fr") return process.env.VUE_APP_SHOP_SUGGESTION_FR
        if (this.locale==="es") return process.env.VUE_APP_SHOP_SUGGESTION_ES
        if (this.locale==="de") return process.env.VUE_APP_SHOP_SUGGESTION_DE
        if (this.locale==="ja") return process.env.VUE_APP_SHOP_SUGGESTION_JP
        if (this.locale==="ar") return process.env.VUE_APP_SHOP_SUGGESTION_AR
        if (this.locale==="pt") return process.env.VUE_APP_SHOP_SUGGESTION_PT
        if (this.locale==="sv") return process.env.VUE_APP_SHOP_SUGGESTION_SV
        if (this.locale==="ru") return process.env.VUE_APP_SHOP_SUGGESTION_RU
        if (this.locale==="th") return process.env.VUE_APP_SHOP_SUGGESTION_TH
        if (this.locale==="tr") return process.env.VUE_APP_SHOP_SUGGESTION_TR
        if (this.locale==="ms") return process.env.VUE_APP_SHOP_SUGGESTION_MS
        if (this.locale==="it") return process.env.VUE_APP_SHOP_SUGGESTION_IT
        if (this.locale==="ko") return process.env.VUE_APP_SHOP_SUGGESTION_KO
        if (this.locale==="nl") return process.env.VUE_APP_SHOP_SUGGESTION_NL
        return process.env.VUE_APP_SHOP_SUGGESTION_EN
      },
      yourperf() {
        if (this.locale==="en") return process.env.VUE_APP_YOUR_PERFUME_EN
        if (this.locale==="fr") return process.env.VUE_APP_YOUR_PERFUME_FR
        if (this.locale==="es") return process.env.VUE_APP_YOUR_PERFUME_ES
        if (this.locale==="de") return process.env.VUE_APP_YOUR_PERFUME_DE
        if (this.locale==="ja") return process.env.VUE_APP_YOUR_PERFUME_JP
        if (this.locale==="ar") return process.env.VUE_APP_YOUR_PERFUME_AR
        if (this.locale==="pt") return process.env.VUE_APP_YOUR_PERFUME_PT
        if (this.locale==="sv") return process.env.VUE_APP_YOUR_PERFUME_SV
        if (this.locale==="ru") return process.env.VUE_APP_YOUR_PERFUME_RU
        if (this.locale==="tr") return process.env.VUE_APP_YOUR_PERFUME_TR
        if (this.locale==="ms") return process.env.VUE_APP_YOUR_PERFUME_MS
        if (this.locale==="it") return process.env.VUE_APP_YOUR_PERFUME_IT
        if (this.locale==="ko") return process.env.VUE_APP_YOUR_PERFUME_KO
        if (this.locale==="nl") return process.env.VUE_APP_YOUR_PERFUME_NL
        if (this.locale==="th") return process.env.VUE_APP_YOUR_PERFUME_TH
        return process.env.VUE_APP_YOUR_PERFUME_EN
      },
      redColor () {
        return process.env.VUE_APP_COLOR
      }
    },
    watch: {
      perfFav(perf) {
        this.callSimilars(perf)
      }
    },
    created () {
      if (process.env.VUE_APP_PFOKEY) {
        this.pfokey = process.env.VUE_APP_PFOKEY
      }
      if (process.env.VUE_APP_CUSTOMERKEY) {
        this.customerkey = process.env.VUE_APP_CUSTOMERKEY
      }
      this.callSimilars(this.perfFav)

    },
    methods: {
      loadPerfumeDetails: function (currentperf, favperf, displayBadge, loadUrl, loadIngredients) {
        
        if (loadIngredients === 'true') {
          this.$emit('set-perfume-details', currentperf, favperf, displayBadge)
          document.getElementById("carddetails").scrollTo({top: 0, behavior: 'smooth'})
        }
        if (loadUrl==="true") {
          localStorage.setItem('pfo_match', JSON.stringify(currentperf))
          localStorage.setItem('pfo_display_clicked_match', JSON.stringify(true))
          localStorage.setItem('pfo_close_after_match', JSON.stringify(true))
          localStorage.setItem('isOpen', JSON.stringify(false))

          this.currentUrl = window.location.hostname //pathname
          if (this.currentUrl !== 'localhost' && this.currentUrl !== 'front-app.perfumist.net') {
            let matchurl = currentperf.url
            if (matchurl !== null) {
              if (typeof process.env.VUE_APP_UNIVERSAL_URL !== 'undefined') {
                if (process.env.VUE_APP_UNIVERSAL_URL === "true") {
                  let langurl = JSON.parse(localStorage.getItem('langPFO'))
                  matchurl = process.env.VUE_APP_CUSTOMER_URL + '/' + langurl + currentperf.url
                  if ((langurl === process.env.VUE_APP_DEFAULT_LANG) && (process.env.VUE_APP_DEFAULT_LANG_URL_ISNULL==="true")) {
                    matchurl = process.env.VUE_APP_CUSTOMER_URL + currentperf.url
                  }
                }
              }
              if (matchurl && matchurl.length > 0)
                window.open(matchurl, "_blank")
            } else { console.log('PFO match url is null') }
          }
        }
        if (loadUrl==="true") {
          if (typeof window._paq !== 'undefined') {window._paq.push(['trackEvent', 'PFO Widget','Match', currentperf.name+' - '+currentperf.brand.name+' - id:'+currentperf.id])}
        }

      },
      loadPerfumeDetails2: function (perfFav) {
        perfFav.name.toString()

        this.twocolors= 'rgba(255,255,255,1)'

        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/'+perfFav.id, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+this.pfokey,
            Accept: "version=2"
          }
        })
          .then(
            res => res.json()
          )
          .then(res => {
            this.Message = "Fetching..."
            this.similars = res.response.similar_products
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.isLoading = false
            //this.isDisabled = false
          })
      },
      callSimilars: function (perf) {

        this.perfFav.name.toString()
        this.twocolors = 'rgba(255,255,255,1)'

        fetch(process.env.VUE_APP_API_BACKEND + '/api/products/' + perf.id+'?locale='+this.locale+'&country_code='+this.country, {
          method: 'GET',
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            Authorization: "Business "+ this.customerkey,
            Accept: "version=2"
          }
        })
          .then(
            res => res.json()
          )
          .then(res => {
            this.Message = "Fetching..."
            this.similars = res.response.similar_products
            this.similars.splice(process.env.VUE_APP_MATCHES_COUNT)
            this.$emit('hide-sugg', this.similars.length == 0)
            
            //this.similars.splice(10)
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.isLoading = false
            //this.isDisabled = false
          })
      },
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      percent: function (value) {
        if (!value) return ''
        value = value*100
        value = value.toString()
        if (value===100) value = value.substring(0,3)+"%"
        else value = value.substring(0,2)+"%"
        return value
      },
      value100: function (value) {
        if (!value) return 0
        value = value*100
        value = value.toString()
        return value
      }
    }

  }
</script>
<style scoped>
  .orders3-layout {
    position: relative;
    width:100%;
    height: 80vh;
    overflow-y: scroll;
    display: block;
    /*white-space: nowrap;*/
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    background-color: white;
    border-radius: 10px;
        border: thin #43454b;
  }

  .favoriteIcon {
    font-size: 50px;
    flex: 0;
    flex-basis: 20%;
  }
  .layoutheight1 {
    height: 60vh; /*348 */
  }
  .layoutheight2 {
    height: 210px; /*348 */
  }
  .favoritelinelayout {
    cursor: pointer;
    position: relative;
    top: 0;
    bottom: 3px;
    right: 0;
    left: 0;
    color: rgba(30,30,30,1);
    background-color: white;
    border-bottom-color: #43454b;
    border-bottom-width: thin;
    flex-wrap: unset;
  }
  .favoritelinelayout:hover {
    background: rgba(0,0,0,.04);
  }

  .match2 {
    :color: redColor;
    font-weight: normal;
    font-size: 14px;
    align-content: center;

  }
  .list__tile__action { min-width: 15px; padding-left: 1%; }
  .justify-center{
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .textoverflow {
    width: 85%;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap;
    display: inline-block;
  }
  .pfo-text-10 {
    font-size: 10px;
  }
  .vperfmarginunset {
    margin: unset;
  }
  .ourselectionline {
    margin-left: 4px;
    margin-right: 4px;
    margin-bottom: 4px;
    border-radius:5px;
  }
  .fav-img {
    height: 50px;
  }
  .match-img {
    height: 72px;
  }
  .wrap2 {
    flex-wrap: wrap;
    height: 100%;
  }
  .pfo-text-word-wrap {
    white-space: normal;
    overflow-wrap: break-word;
  }
  .fxsp {
    font-size: 10px;
  }
  .rounded-card{
    border-radius:5px;
  }
  .pfo-mato-match{
    font-size: inherit;
  }
  .topCard {
    border: thin #43454b;
    border-radius:15px;
    border-bottom-color: #43454b;
    background-color: white;
  }
    .carddetails2 {
      border: thin #43454b;
      border-radius:15px;
      border-bottom-color: #43454b;
      background-color: white;
      overflow: scroll;

  }

  .perfName {
    margin-top: auto;
    margin-left: auto;
    margin-right: auto;
    font-size: 22px;
    color: rgba(30,30,30,0.7);
  }

  .perfBrand {
    font-size: 18px;
    color: rgba(30,30,30,0.7);
  }

</style>
